/**
 * TptAI Scrolling Text V4 Section
 * JavaScript for initializing and controlling the testimonial slider
 */

class TptAIScrollingTextV4 extends HTMLElement {
  constructor() {
    super();
    this.sliders = [];
    this.init();
  }

  init() {
    // Initialize all sliders within the section
    document.addEventListener('DOMContentLoaded', () => {
      this.initSliders();
    });
  }

  initSliders() {
    const sliderElements = document.querySelectorAll('tpt-slider');
    
    sliderElements.forEach(slider => {
      // Get options from the hidden options element
      const optionsElement = slider.querySelector('tpt-slider-options');
      if (!optionsElement) return;
      
      try {
        const options = JSON.parse(optionsElement.textContent.trim());
        const swiperContainer = slider.querySelector('.swiper');
        
        if (swiperContainer) {
          // Initialize Swiper with the parsed options
          const swiper = new Swiper(swiperContainer, {
            ...options,
            // Add navigation if elements exist
            navigation: {
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev'),
            },
            // Add pagination if element exists
            pagination: {
              el: slider.querySelector('.swiper-paginations'),
              clickable: true,
              ...options.pagination
            },
            // Accessibility improvements
            a11y: {
              prevSlideMessage: 'Previous testimonial',
              nextSlideMessage: 'Next testimonial',
              firstSlideMessage: 'This is the first testimonial',
              lastSlideMessage: 'This is the last testimonial',
              paginationBulletMessage: 'Go to testimonial {{index}}'
            }
          });
          
          this.sliders.push(swiper);
        }
      } catch (error) {
        console.error('Error initializing slider:', error);
      }
    });
  }
}

// Register the custom element
customElements.define('tpt-slider', TptAIScrollingTextV4);